import InternalEventBus from "../../../../core/utils/internalEventBus.js";
import DataStore from "../../../../core/stores/dataStore.js";
import ChartUtil from "../timeseries-chart/chart-util.js";

module.exports = function (model, widgetId, legends) {
  // line static domain controller
  // //////// private members
  var _this = this;
  var chart = null;
  var divId = widgetId + "-" + model.id;
  var initialData;
  var componentId = model.id;
  var callbackIds = [];
  var subscriptionTokens = [];

  function init() {
    for (var i = 0; i < legends.length; ++i) {
      var callbackId = legends[i].id;
      callbackIds.push(callbackId);
      var token = InternalEventBus.subscribe(legends[i].datasetId, _this.update);
      subscriptionTokens.push(token);
    }
  }

  function createData(legends) {
    //data1[0].values.push({x: counter, y: Math.sin(x), xLabel: counter + " h"});
    //data1[1].values.push({x: counter, y: taylorSin(x), xLabel: counter + " h"});

    var initialData = [];
    for (var i = 0; i < legends.length; ++i) {
      var datasetId = legends[i].datasetId;
      var latestData = DataStore.get(datasetId);

      // populate values array
      var values = [];
      if (latestData != null) {
        for (var xValue in legends[i].valueFields) {
          var fieldId = legends[i].valueFields[xValue];
          var currentValue = {
            x: xValue,
            y: latestData[fieldId] || null,
            xLabel: fieldId
          };
          values.push(currentValue);
        }
      }

      initialData.push({
        label: "DataSeries" + i,
        values: values
      });
    }

    // fill null values
    var consecutiveNullData = [];
    for (var i = 0; i < initialData.length; ++i) {
      var values = initialData[i].values;
      for (var j = 0; j < values.length; ++j) {
        if (values[j].y == null) {
          consecutiveNullData.push(values[j]);
        }
        else if (values[j].y != null && consecutiveNullData.length > 0) {
          var currentY = values[j].y;
          var startY = values[j - consecutiveNullData.length - 1].y;
          var incrementValue = (currentY - startY) / (consecutiveNullData.length + 1);
          for (var k = 0; k < consecutiveNullData.length; ++k) {
            startY = startY + incrementValue;
            consecutiveNullData[k].y = startY;
          }
          consecutiveNullData = [];
        }
      }
      consecutiveNullData = [];
    }

    return initialData;
  }

  // //////// public members
  this.id = componentId;
  this.widgetId = widgetId;

  this.destroy = function () {
    if (chart) {
      chart.destroy();
    }

    for(var i=0; i<subscriptionTokens.length; i++) {
      InternalEventBus.unsubscribe(subscriptionTokens[i]);
    }
  };

  this.update = function () {
    var data;
    if (chart) {
      data = createData(legends);
      chart.update(data);
    }
    else {
      data = createData(legends);
      if (allDataInitialized(data)) {

        var container = $("#" + divId).parent("div").parent("div");

        var $chart = $("#" + divId);
        chart = $chart.epoch({
          type: 'line',
          data: data,
          domain: [1, 11],
          tickFormats: {
            bottom: function (index) {
              if (index.toString().indexOf('.') > -1) {
                return "";
              }
              else {
                return "Rate" + index;
              }
            }
          }
        });

        ChartUtil.resizeCharts(widgetId, container.height(), container.width());
      }
    }
  };

  function allDataInitialized(initialData) {
    for (var i = 0; i < initialData.length; ++i) {
      if (initialData[i].values.length === 0) {
        return false;
      }
    }

    return true;
  }

  this.doesNotHaveAnyLegends = function () {
    return false;
  };

  // TODO: history size is how many data points does the chart display prior to start
  // updating itself on real-time updates. This value is hard-coded for now.
  this.getHistorySize = function () {
    return 1;
  }

  this.getLegends = function () {
    return legends;
  };

  init();
}


// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/line-static-chart/controller.js